module.exports = __webpack_public_path__ + "assets/fanyi.3040ae46.svg";